/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Entry/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Entry({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/LedgerTab/Content/Content/CollectionStatus/Content/Entry"
  
}) {
let entryItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'entry_item',
path: 'isFirst',
})
let entryDueValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
path: 'due',
format: fromFormat.numberMoney,
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let entryNameValueData = fromData.useDataValue({ viewPath,
context: 'entry',
path: 'name',
})
let entryTimeIntervalValueData = fromData.useDataValue({ viewPath,
context: 'entry',
path: 'time_interval',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Entry.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-4PFPn': entryItemIsFirstValueData ? "0px" : "4px"}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 color={dtColorsWhite}
 data="entry.due"
 format="/Data/format.js numberMoney"
 text={entryDueValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 color={dtColorsWhite}
 marginRight={4}
 text=":"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 weight="medium"
 color={dtColorsWhite}
 data="entry.name"
 text={entryNameValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text=","
 color={dtColorsWhite}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXs}
 data="entry.time_interval"
 text={entryTimeIntervalValueData}
 size="tiny"
 color={dtColorsWhite}
/>
</div>
{children}
</React.Fragment>)
}